import { CustomLink } from "@/components/CustomLink";
import { LinkType } from "@/types/baseTypes";
import React from "react";
import styles from "./BottomLink.module.scss";
import CustomSVG from "@/components/_primitives/CustomSVG/CustomSVG.client";
import { SanitizedText } from "./MegaMenu";

function BottomLink({
  link,
  onClick,
  getIcon,
}: {
  link: LinkType;
  onClick?: void;
  getIcon: (key: string) => string;
}) {
  return (
    link && (
      <CustomLink
        className={`${styles["mega-menu-more-link"]} mega-menu-more-link`}
        href={link.url}
        target={link.target}
        {...(onClick ? { onClick: onClick } : {})}
        disablePrefetch
      >
        <CustomSVG
          width={26}
          height={18}
          src={getIcon("bare_arrow_right")}
          wrapper={"span"}
          aria-hidden="true"
        />
        <SanitizedText text={link.title} />
      </CustomLink>
    )
  );
}

export default BottomLink;
